import { useState } from "react";
import { addTransaction } from "../../../services/Entry/transactionService";
import { usePartners } from "../../../hooks/Entry/usePartners";
import { useTransactionForm } from "../../../hooks/Entry/useTransactionForm";

import PartnerList from "./PartnersList";
import AddPartner from "./AddPartner";
import TransactionForm from "./TransactionForm";
import ConfirmationModal from "../../../utils/ConfirmationModal/ConfirmationModal";

import "../styles/container.css";
import BulkUpload from "./BulkUpload";
import { refreshUserTransactions } from "../../../utils/refreshUser";
import Loader from "../../../utils/Loader/Loader";

const StockForm = ({ userId, showToast }) => {
  const [selectedPartner, setSelectedPartner] = useState(null);

  // ✅ NEW STATES
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editName, setEditName] = useState("");
const [editShare, setEditShare] = useState("");
const [globalLoading, setGlobalLoading] = useState(false);
  // ✅ UPDATED HOOK
  const {
  partners,
  createPartner,
  removePartner,
  editPartner,

  isAddingPartner,
  isDeletingPartner,
  isEditingPartner

} = usePartners(userId, showToast);
const [isSubmitting, setIsSubmitting] = useState(false);
  const { form, updateField, resetForm } = useTransactionForm();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedPartner) {
      showToast("Select a partner", "warning");
      return;
    }

    try {
      setIsSubmitting(true);
      await addTransaction(userId, selectedPartner.id, {
        ...form,
        rate: parseFloat(form.rate),
        quantity: parseInt(form.quantity),
        amount: parseFloat(form.amount),
        partner: selectedPartner.name,
        createdAt: new Date()
      });

      await refreshUserTransactions(userId);

      showToast("Transaction added!", "success");
      resetForm();
    } catch (err) {
      console.error(err);
      showToast("Error adding transaction", "error");
    } finally{
      setIsSubmitting(false);
    }
  };

  // ✅ DELETE HANDLERS
  const handleDelete = (partner) => {
    setSelectedPartner(partner);
    setShowConfirm(true);
  };

  const confirmDelete = async () => {
    setLoading(true);
    await removePartner(selectedPartner.id);
    setLoading(false);
    setSelectedPartner(null);
    setShowConfirm(false);
  };

  // ✅ EDIT HANDLERS
  const handleEdit = (partner) => {
  setEditMode(true);
  setEditName(partner.name);
  setEditShare(partner.myShare);
};

  const saveEdit = async () => {
  await editPartner(selectedPartner.id, {
    name: editName,
    myShare: editShare
  });

  // ✅ instant UI update (optional but recommended)
  setSelectedPartner(prev => ({
    ...prev,
    name: editName,
    myShare: editShare
  }));

  setEditMode(false);
};

  return (
    <div className="entry-container">
      {isSubmitting && (
    <Loader text="Entering transaction..." />
  )}
  {(isAddingPartner || isDeletingPartner || isEditingPartner) && (
  <Loader
    text={
      isAddingPartner
        ? "Adding partner..."
        : isDeletingPartner
        ? "Deleting partner..."
        : "Updating partner..."
    }
  />
)}
      <h2>Stock Entry</h2>

      <PartnerList
        partners={partners}
        selected={selectedPartner}
        onSelect={setSelectedPartner}
        onEdit={handleEdit}       // ✅ NEW
        onDelete={handleDelete}   // ✅ NEW
        isDeletingPartner={isDeletingPartner}
        isEditingPartner={isEditingPartner}
      />
      {!selectedPartner && (
  <p className="upload-hint">
    Select a partner to upload transactions
  </p>
)}
      
      {/* ✅ EDIT UI */}
{editMode && (
  <div className="edit-partner">
    <input
      type="text"
      placeholder="Partner Name"
      value={editName}
      onChange={(e) => setEditName(e.target.value)}
    />

    <input
      type="number"
      placeholder="Your %"
      value={editShare}
      onChange={(e) => setEditShare(e.target.value)}
    />

    <button
  onClick={saveEdit}
  disabled={isEditingPartner}
>
  {isEditingPartner ? "Saving..." : "Save"}
</button>
    <button onClick={() => setEditMode(false)}>Cancel</button>
  </div>
)}

      <AddPartner
  onAdd={createPartner}
  isAddingPartner={isAddingPartner}
/>
{selectedPartner && (
  <BulkUpload
    userId={userId}
    selectedPartner={selectedPartner}
    showToast={showToast}
    setGlobalLoading={setGlobalLoading}
  />
)}

      {selectedPartner && (
        <TransactionForm
          form={form}
          updateField={updateField}
          onSubmit={handleSubmit}
          partner={selectedPartner}
          isSubmitting={isSubmitting}
        />
      )}

      {/* ✅ DELETE CONFIRMATION */}
      {showConfirm && (
        <ConfirmationModal
          message="Delete this partner and all transactions?"
          onConfirm={confirmDelete}
          onCancel={() => setShowConfirm(false)}
          loading={loading}
        />
      )}
      {globalLoading && (
  <div className="loading-overlay">
    <div className="spinner"></div>
    <p>Uploading transactions...</p>
  </div>
)}
    </div>
  );
};

export default StockForm;